module.exports = __webpack_public_path__ + "img/entree-icon.998b4f41.png";